"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _gatsby = require("gatsby");

var _moment = _interopRequireDefault(require("moment"));

var _lodash = require("lodash");

var _useBlogRoll = require("../../../src/hooks/use-blog-roll");

var _useBlogRollHome = require("../../../src/hooks/use-blog-roll-home");

var _useFeaturedTags = require("../../../src/hooks/use-featured-tags");

var _PreviewCompatibleImage = _interopRequireDefault(require("./PreviewCompatibleImage"));

var BlogRoll = function BlogRoll(props) {
  var posts, tags;
  var today = (0, _moment["default"])().valueOf();

  if (props.isHome) {
    posts = (0, _useBlogRollHome.useBlogRollHome)();
    posts = posts && posts.filter(function (_ref) {
      var post = _ref.node;
      return post.fields.langKey === "".concat(props.langKey) && post.frontmatter.homePageControls.show && (post.frontmatter.homePageControls.start !== "" && post.frontmatter.homePageControls.start !== null && post.frontmatter.homePageControls.end !== "" && post.frontmatter.homePageControls.end !== null && today >= (0, _moment["default"])(new Date(post.frontmatter.homePageControls.start)).valueOf() && today <= (0, _moment["default"])(new Date(post.frontmatter.homePageControls.end)).valueOf() || post.frontmatter.homePageControls.start !== "" && post.frontmatter.homePageControls.start !== null && (post.frontmatter.homePageControls.end === "" || post.frontmatter.homePageControls.end === null) && today >= (0, _moment["default"])(new Date(post.frontmatter.homePageControls.start)).valueOf() || (post.frontmatter.homePageControls.start === "" || post.frontmatter.homePageControls.start === null) && post.frontmatter.homePageControls.end !== "" && post.frontmatter.homePageControls.end !== null && today <= (0, _moment["default"])(new Date(post.frontmatter.homePageControls.end)).valueOf() || (post.frontmatter.homePageControls.start === "" || post.frontmatter.homePageControls.start === null) && (post.frontmatter.homePageControls.end === "" || post.frontmatter.homePageControls.end === null));
    });
    tags = (0, _useFeaturedTags.useFeaturedTags)();
    tags = tags.tagList.filter(function (tag) {
      return tag.featuredHome;
    });
  } else if (props.isTags) {
    posts = props.data;
    posts = posts && posts.filter(function (_ref2) {
      var post = _ref2.node;
      return post.fields.langKey === "".concat(props.langKey);
    });
  } else {
    posts = (0, _useBlogRoll.useBlogRoll)();
    posts = posts && posts.filter(function (_ref3) {
      var post = _ref3.node;
      return post.fields.langKey === "".concat(props.langKey);
    });
  }

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "columns is-multiline"
    }, posts && posts.map(function (_ref4) {
      var post = _ref4.node;
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "is-parent column is-6",
          key: post.id
        },
        /*#__PURE__*/
        _react["default"].createElement("article", {
          className: "blog-list-item tile is-child box notification ".concat(post.frontmatter.featuredPost ? 'is-featured' : '')
        },
        /*#__PURE__*/
        _react["default"].createElement("header", null, post.frontmatter.featuredImage ?
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "featured-thumbnail"
        },
        /*#__PURE__*/
        _react["default"].createElement(_PreviewCompatibleImage["default"], {
          imageInfo: {
            image: post.frontmatter.featuredImage,
            alt: "featured image thumbnail for post ".concat(post.frontmatter.title)
          }
        })) : null,
        /*#__PURE__*/
        _react["default"].createElement("p", {
          className: "post-meta"
        },
        /*#__PURE__*/
        _react["default"].createElement(_gatsby.Link, {
          className: "title has-text-primary is-size-10",
          to: post.fields.pathSlug
        }, post.frontmatter.title),
        /*#__PURE__*/
        _react["default"].createElement("span", null, " \u2022 "),
        /*#__PURE__*/
        _react["default"].createElement("span", {
          className: "subtitle is-size-14 is-block"
        }, post.frontmatter.createDate !== "" && post.frontmatter.createDate !== null && post.frontmatter.updateDate !== "" && post.frontmatter.updateDate !== null && (0, _moment["default"])(new Date(post.frontmatter.createDate)).format('YYYY.MM.DD') !== (0, _moment["default"])(new Date(post.frontmatter.updateDate)).format('YYYY.MM.DD') &&
        /*#__PURE__*/
        _react["default"].createElement("p", null, "Created: ".concat((0, _moment["default"])(new Date(post.frontmatter.createDate)).format('YYYY.MM.DD')), ' | ', "Last updated: ".concat((0, _moment["default"])(new Date(post.frontmatter.updateDate)).format('YYYY.MM.DD'))), post.frontmatter.createDate !== "" && post.frontmatter.createDate !== null && post.frontmatter.updateDate !== "" && post.frontmatter.updateDate !== null && (0, _moment["default"])(new Date(post.frontmatter.createDate)).format('YYYY.MM.DD') === (0, _moment["default"])(new Date(post.frontmatter.updateDate)).format('YYYY.MM.DD') &&
        /*#__PURE__*/
        _react["default"].createElement("p", null, "Created: ".concat((0, _moment["default"])(new Date(post.frontmatter.createDate)).format('YYYY.MM.DD'))), (post.frontmatter.createDate === "" || post.frontmatter.createDate === null) && post.frontmatter.updateDate !== "" && post.frontmatter.updateDate !== null &&
        /*#__PURE__*/
        _react["default"].createElement("p", null, "Created: prior to 2018", ' | ', "Last updated: ".concat((0, _moment["default"])(new Date(post.frontmatter.updateDate)).format('YYYY.MM.DD'))), post.frontmatter.createDate !== "" && post.frontmatter.createDate !== null && (post.frontmatter.updateDate === "" || post.frontmatter.updateDate === null) &&
        /*#__PURE__*/
        _react["default"].createElement("p", null, "Created: ".concat((0, _moment["default"])(new Date(post.frontmatter.createDate)).format('YYYY.MM.DD'))), (post.frontmatter.createDate === "" || post.frontmatter.createDate === null) && (post.frontmatter.updateDate === "" || post.frontmatter.updateDate === null) &&
        /*#__PURE__*/
        _react["default"].createElement("p", null, "Created: prior to 2018")))), post.frontmatter.description &&
        /*#__PURE__*/
        _react["default"].createElement("p", null, post.frontmatter.description.length > 400 ?
        /*#__PURE__*/
        _react["default"].createElement("div", null, "".concat(post.frontmatter.description.substring(0, 400), "...")) :
        /*#__PURE__*/
        _react["default"].createElement("div", null, post.frontmatter.description))))
      );
    }), tags && tags.map(function (tag) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "is-parent column is-6",
          key: tag.id
        },
        /*#__PURE__*/
        _react["default"].createElement("article", {
          className: "blog-list-item tile is-child box notification ".concat(tag.featured ? 'is-featured' : '')
        }, tag.translations && tag.translations.filter(function (translation) {
          return translation.langKey === props.langKey;
        }).map(function (translation) {
          return (
            /*#__PURE__*/
            _react["default"].createElement(_react["default"].Fragment, null,
            /*#__PURE__*/
            _react["default"].createElement("header", null,
            /*#__PURE__*/
            _react["default"].createElement("p", {
              className: "post-meta"
            },
            /*#__PURE__*/
            _react["default"].createElement(_gatsby.Link, {
              className: "title has-text-primary is-size-10",
              to: "".concat(props.langKey === "en" || props.langKey === undefined ? "" : props.langKey).concat(tag.tag)
            }, (0, _lodash.startCase)(translation.tagDisplay)),
            /*#__PURE__*/
            _react["default"].createElement("span", null, " \u2022 "))), translation.longDesc &&
            /*#__PURE__*/
            _react["default"].createElement("p", null, translation.longDesc.length > 400 ?
            /*#__PURE__*/
            _react["default"].createElement("div", null, "".concat(translation.longDesc.substring(0, 400), "...")) :
            /*#__PURE__*/
            _react["default"].createElement("div", null, translation.longDesc)))
          );
        })))
      );
    }))
  );
};

var _default = BlogRoll;
exports["default"] = _default;